import React from 'react'

export default function FraudDetection() {
  const data:any = [
    {ClaimID: '40', ProviderID: 'A'},
    {ClaimID: '40', ProviderID: 'A'},
    {},
    {},

  ];



  return (
    <div className=' container'style={{margin:"30px"}} >
      {/* title */}
<h5>FraudDetectionScreen <span> <i className='bi bi-people '></i> </span> <span><a href="" style={{marginLeft:"30px"}}>Click to Download template</a></span>   </h5>
{/* first row input */}
<div className=' row'>
<div className="input-group w-50 ">
  <input type="file" className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload"/>
  
  <button className="btn btn-secondary" type="submit"  style={{marginLeft:"10px", padding:"8px"}}> <span className=' m-1 '><i className="fa-solid fa-upload"></i></span>Upload</button>
</div>

</div>
{/* second row input */}

<div className=' row d-flex flex-row ' style={{ marginTop:"20px"}}>
 <select name="providerName" id=""className=' p-1 ' style={{width:"20%"}} >
  

<option value="providerName">Provider Name</option>

 </select>
<input type="date"   className='  p-1 form-control'style={{marginLeft:"7px",width:"20%"}}  />
<input type="date"  className='  p-1 form-control'style={{marginLeft:"7px",width:"20%"}} />
<input type="text"  placeholder='Claim ID' className='  p-1 form-control ' style={{marginLeft:"7px",width:"20%"}}/>


     <input type="text" className="form-control " placeholder="Search "style={{marginLeft:"7px",width:"15%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>




</div>
  {/*third row input */}

<div className=' row d-flex flex-row ' style={{ marginTop:"20px"}}>
  <select name="ClaimStatus" id=""className='  p-1 '  style={{width:"20%"}}>
  

  <option value="Claim Status">Claim Status</option>
  
   </select>
   <select name="CaseType" id=""className='  p-1 ' style={{marginLeft:"7px",width:"20%"}} >
  

  <option value="CaseType">Case Type</option>
  
   </select>
   <select name="FacilityId" id=""className='  p-1 ' style={{marginLeft:"7px",width:"20%"}} >
  

  <option value="FacilityId">Facility Id</option>
  
   </select>
   <input type="text"  placeholder='Price From   TO' className=' p-2 form-control ' style={{marginLeft:"7px",width:"20%"}}/>

  <input type="text"  placeholder='Department' className='  p-2 form-control ' style={{marginLeft:"7px",width:"15%"}}/>




</div>
{/* table */}
<table style={{  width: '100%' , marginTop:"40px" }}>
      <thead>
        <tr>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}></th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>IDv</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>ClaimID</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>ProviderID</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>TranDate</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>Gross</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>NET</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>Insurencepay</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>Status</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>UploadDate</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }} className='text-center'>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item:any,index:number) => (
          <tr key={item.id} className=' text-center' style={{
            background: index % 2 === 0 ? '#74C0FC' : '#ffffff', 
            border: '1px solid #ddd',
            padding: '8px',
          }}>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}><input type="checkbox" id="Remmber" /> </td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.ClaimID}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.ProviderID}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
          
            <td style={{ border: '1px solid #ddd', padding: '8px' }}><span><i className="fa fa-solid fa-edit m-2"> </i>
            <i className="fa-solid fa-trash"></i></span></td> 
          </tr>

        ))}
      </tbody>
    </table>
    {/* last row input */}
    <div className="row d-flex justify-content-end m-4">
    <button className="btn btn-success w-25" type="submit"  style={{marginLeft:"10px", padding:"5px"}}><span className=' m-2'><i className="fa-solid fa-paper-plane"></i></span>Send Notification</button>
    <button className="btn btn-success w-25" type="submit"  style={{marginLeft:"10px", padding:"5px"}}> <span className=' m-2'><i className="fa-solid fa-exclamation"></i></span>Notify</button>
    <button className="btn btn-danger w-25" type="submit"  style={{marginLeft:"10px", padding:"5px"}}> <span className=' m-2'><i className="fa-solid fa-magnifying-glass"></i></span> Check For Fraud</button>

    </div>
    </div>
  )
}
